<template>
    <v-container id="facturas-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    class="alineacentro DatosMatriculado"
                    dark
                    color="success"
                  >
                    <strong>FACTURAS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="2" lg="2">
                  <v-menu
                    v-model="menufiltrofdesde"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocalfdesde"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        height="20px"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros.desde"
                      @input="menufiltrofdesde = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-menu
                    v-model="menufiltrofhasta"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocalfhasta"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        height="20px"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros.hasta"
                      @input="menufiltrofhasta = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.idpuntoventa"
                    :items="listapuntosventafiltro"
                    label="Punto Venta"
                    item-text="nombre"
                    item-value="idpuntoventa"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-text-field
                    v-model="filtros.facturanro"
                    label="N° Factura"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-text-field
                    v-model="filtros.concepto"
                    label="Concepto"
                    height="20px"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="6" lg="6">
                  <selector-alumno
                    ref="selalumnofiltro"
                    class="alineaizquierda"
                    @selAlumno="asignaalumnofiltro"
                    :nivel=0
                  ></selector-alumno>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <selector-persona
                    ref="selpersonafiltro"
                    class="alineaizquierda"
                    @selPersona="asignapersonafiltro"
                    :idalumno="filtros.idalumno"
                    titulo="Persona Factura"
                  ></selector-persona>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="Listar('')"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Nueva Factura"
                    @click="Nueva"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-new-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Informar Factura en AFIP"
                    @click="InformaAFIP"
                    :disabled="facturaseleccionada.length === 0 || !permisoescritura || facturaseleccionada[0].idestadocomprobante===2 || facturaseleccionada[0].idestadocomprobante===4 || (facturaseleccionada[0].idestadocomprobante===3 && facturaseleccionada[0].cae!=null && facturaseleccionada[0].cae!='')"
                  >
                    AFIP <v-icon dark> mdi-file-send </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Anular Factura"
                    @click="AbreCuadroAnularFactura"
                    :disabled="facturaseleccionada.length === 0 || !permisoescritura || facturaseleccionada[0].idestadocomprobante === 4"
                  >
                    <v-icon dark> mdi-close </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="success"
                    title="Re-Imprimir Factura"
                    @click="AbrirCuadroReImprimir"
                    :disabled="facturaseleccionada.length === 0 || !permisolectura || facturaseleccionada[0].idestadocomprobante === 4"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="success"
                    title="Imprimir Nota de Crédito"
                    @click="ImprimirNotaCredito"
                    :disabled="facturaseleccionada.length === 0 || !permisolectura || facturaseleccionada[0].idestadocomprobante != 4"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Imprimir o Exportar Listado"
                    @click="AbrirCuadroImprimirExportar"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    v-model="facturaseleccionada"
                    :headers="columnasfacturas"
                    :items="listafacturas"
                    :items-per-page="15"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    single-select
                    show-select
                    item-key="idfactura"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.cae="{ item }">
                      <v-chip :color="getcolorcae(item.cae)" dark>
                        <p class="textofilagrilla">{{ item.cae!=null && item.cae.length>0 ? item.cae : 'SIN INFORMAR AFIP' }}</p>
                      </v-chip>
                    </template>
                    <template v-slot:item.estadocomprobante="{ item }">
                      <v-chip :color="getcolor(item.idestadocomprobante)" dark>
                        <p class="textofilagrilla">{{ item.estadocomprobante }}</p>
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">
            {{ mensajetitulo }}
            </v-card-title>
            <v-card-text>
            {{ mensajecuerpo }}
            </v-card-text>
            <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
            fluid
            class="full-height"
            style="background-color: rgba(255, 255, 255, 0.5)"
        >
            <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
            >
            <v-col class="elementocentrado">
                <v-progress-circular indeterminate color="primary" />
            </v-col>
            </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevafactura" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Nueva Factura
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarFactura">
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialognuevafactura = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row row wrap>
              <v-col cols="12" md="9" lg="9">
                <br />
                <v-card flat height="auto" color="grey" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>CABECERA</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12" md="4" lg="4">
                        <v-text-field
                            v-model="factura.concepto"
                            label="Concepto"
                            height="20px"
                        />
                      </v-col>
                      <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                        <v-select
                            v-model="factura.idpuntoventa"
                            :items="listapuntosventa"
                            label="Punto Venta"
                            item-text="nombre"
                            item-value="idpuntoventa"
                            class="ocupa90"
                            height="20px"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="1"
                        lg="1"
                        class="alineacentro"
                        v-if="factura.idpuntoventa != '' && listapuntosventa.filter((t) => t.idpuntoventa === factura.idpuntoventa)[0].idtipo === 1"
                      >
                        <v-text-field
                          :value="parseInt(listapuntosventa.filter((t) => t.idpuntoventa === factura.idpuntoventa)[0].ultnrorecibo) + 1"
                          label="N° Recibo"
                          class="ocupa90"
                          height="20px"
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        :md="factura.idpuntoventa != '' && listapuntosventa.filter((t) => t.idpuntoventa === factura.idpuntoventa)[0].idtipo === 1 ? 2 : 3"
                        :lg="factura.idpuntoventa != '' && listapuntosventa.filter((t) => t.idpuntoventa === factura.idpuntoventa)[0].idtipo === 1 ? 2 : 3"
                        class="alineaizquierda"
                      >
                        <v-menu
                            v-model="menuffac"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="fechalocalfactura"
                                label="Fecha"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                class="ocupa90"
                                height="20px"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="factura.fecha"
                            @input="menuffac = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12" md="1" lg="1" class="alineaizquierda">
                        <br />
                        Alumno:
                      </v-col>
                      <v-col cols="12" md="9" lg="9" class="alineaizquierda">
                        <selector-alumno
                            ref="selalumnoedit"
                            class="alineaizquierda"
                            @selAlumno="asignaalumnoedit"
                            :nivel=0
                        ></selector-alumno>
                      </v-col>
                      <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                        <v-checkbox v-model="facdistintotitular"
                          label="Otro Tit. Factura"
                        />
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="cursoactualalumno.length>0">
                      <v-col cols="12" md="10" lg="10">
                        <p class="textoNegritaTitulo">Datos del Alumno: <span class="textoNegritaAzul">{{ cursoactualalumno }}</span></p>
                      </v-col>
                      <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="facdistintotitular">
                      <v-col cols="12" class="alineaizquierda">
                        <!-- <selector-persona
                            ref="selpersonaedit"
                            class="alineaizquierda"
                            @selPersona="asignapersonaedit"
                            :idalumno="factura.idalumno"
                            titulo="Persona Factura"
                        ></selector-persona> -->
                        <v-select
                            v-model="factura.idpersonafactura"
                            :items="listapersonasvinculadas"
                            label="Titular"
                            item-text="persona"
                            item-value="idpersona"
                            height="20px"
                            v-on:change="SeleccionaPersonaFactura"
                        />
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="listanovedadesalumno.length>0">
                      <v-col cols="12" class="alineaizquierda">
                        Novedades del Alumno
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="listanovedadesalumno.length>0">
                      <v-col cols="12" class="alineaizquierda">
                        <v-data-table
                            :headers="columnasnovedades"
                            :items="listanovedadesalumno"
                            hide-default-footer
                            item-key="idformapago"
                            no-data-text="Sin Registros"
                            multi-sort
                        >
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <br />
                <v-card flat height="auto" color="grey" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>TOTALES</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="red"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">A COBRAR:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontofactura().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="success"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">DESCUENTOS:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontodescuentos().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="red"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">RECARGOS:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontorecargos().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap v-if="sumamontopagos()<0">
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            color="success"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">PAGOS:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumamontopagos().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <br />
                        <v-divider :thickness="6" color="black" opacity="75" />
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="28"
                            dark
                            :color="sumatotal() <= 0 ? 'success' : 'red'"
                            class="alineaderecha"
                        >
                          <v-card-text>
                            <v-row>
                                <v-col cols="12" md="5" lg="5" class="alineaizquierda">
                                    <strong class="textoNegritaMontos textoColorBlanco">SALDO:</strong>
                                </v-col>
                                <v-col cols="12" md="7" lg="7" class="alineaderecha">
                                    <strong class="textoNegritaMontos textoColorBlanco">$ {{ sumatotal().toFixed(2) }}</strong>
                                </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-card flat height="auto" color="grey" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>DETALLE</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-card
                            flat
                            height="auto"
                            color="blue"
                            class="alineacentro"
                        >
                          <v-card-text>
                            <v-row row wrap>
                              <v-col cols="12" md="4" lg="4">
                                <v-select
                                  v-model="nuevodetalle.idconcepto"
                                  :items="listaconceptosafacturar"
                                  label="Concepto"
                                  item-text="nombre"
                                  item-value="idconcepto"
                                  height="20px"
                                />
                              </v-col>
                              <v-col cols="12" md="4" lg="4">
                                <v-text-field
                                    v-model="nuevodetalle.descripcion"
                                    label="Descripción"
                                    height="20px"
                                />
                              </v-col>
                              <v-col cols="12" md="2" lg="2">
                                <v-text-field
                                    ref="importecuentadebe"
                                    v-model="nuevodetalle.importe"
                                    label="Importe"
                                    type="number"
                                    prefix="$"
                                    height="20px"
                                />
                              </v-col>
                              <v-col cols="12" md="2" lg="2">
                                <v-btn
                                    class="ma-2"
                                    x-small
                                    color="primary"
                                    title="Agregar Detalle"
                                    @click="AgregaDetalle"
                                >
                                  <v-icon dark> mdi-cash-plus</v-icon>
                                </v-btn>
                                <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Detalles Desde CC"
                                    @click="BuscaItemCC"
                                >
                                  <v-icon dark> mdi-account-cash </v-icon>
                                </v-btn>
                                <v-btn
                                    class="ma-2"
                                    dark
                                    x-small
                                    color="primary"
                                    title="Agregar Cuota"
                                    @click="BuscaCuotas"
                                >
                                  <v-icon dark> mdi-account-cash </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row row wrap>
                              <v-col cols="12">
                                <v-data-table
                                    :headers="columnasdetalles"
                                    :items="factura.detalles"
                                    :items-per-page="10"
                                    :footer-props="{
                                      'items-per-page-text': 'Filas por Página:',
                                      'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="id"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Registros"
                                >
                                  <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="QuitarDetalle(item)">
                                        mdi-delete
                                    </v-icon>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-card flat height="auto" color="success" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>PAGOS</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12" class="alineaderecha">
                        <v-btn
                            class="ma-2"
                            dark
                            x-small
                            color="primary"
                            title="Agregar Pago"
                            @click="AgregarPago"
                        >
                            <v-icon dark> mdi-cash-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12">
                        <v-data-table
                            v-model="itemabonoseleccionado"
                            :headers="columnasabonos"
                            :items="factura.itemsabonos"
                            hide-default-footer
                            item-key="idformapago"
                            class="elevation-1"
                            dense
                            no-data-text="Sin Registros"
                            multi-sort
                        >
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              small
                              @click="QuitarPago(item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevodetalleCC" persistent max-width="1200">
        <v-card>
          <v-card-title class="headline">
            Agregar Items desde CC del Estudiante: {{ facalumno }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="SeleccionarItemsCC">
                  Seleccionar Items
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevodetalleCC = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <v-row row wrap>
              <v-col cols="12" lg="4" md="4" class="alineaizquierda">
                <v-menu
                  v-model="menufcalculo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfcalculo"
                      label="Fecha Cálculo"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fechacalculocc"
                    @input="menufcalculo = false"
                    @change="ListaCCAlumno()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="8" md="8" class="alineaizquierda">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar Mov. Pendientes de la CC"
                  @click="ListaCCAlumno()"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" class="alineaderecha info textoNegritaTitulo textoColorBlanco">
                Total Seleccionado: $ {{ sumaitemsselcc() }}
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                    v-model="itemsccseleccionado"
                    :headers="columnascc"
                    :items="listacc"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    show-select
                    item-key="idmovimiento"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogpagos" persistent fullscreen>
        <v-card>
          <v-card-title class="headline"> Nuevo Pago </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                Saldo abonar: {{ sumatotal().toFixed(2) }}
              </v-col>
              <v-col cols="12" md="10" lg="10" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GuardarPago">
                    Guardar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialogpagos=false">
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-spacer />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" lg="3" md="3" class="alineaizquierda">
                <v-select
                    v-model="nuevoabono.idformapago"
                    :items="listaformaspago"
                    label="Forma Pago"
                    item-text="nombre"
                    item-value="idformapago"
                    height="20px"
                />
              </v-col>
              <v-col cols="12" lg="3" md="3" class="alineaizquierda">
                <v-text-field v-model="nuevoabono.importe"
                    label="Importe"
                    type="number"
                    prefix="$"
                    height="20px"
                />
              </v-col>
              <v-col cols="12" lg="6" md="6" class="alineaizquierda">
                <v-text-field v-model="nuevoabono.observacion"
                    label="Observación"
                    height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Agregar Comprobante Pago"
                  @click="AgregarRegistroPago"
                >
                  <v-icon dark> mdi-cash-plus </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                  :headers="columnasregistrosabono"
                  :items="nuevoabono.registros"
                  hide-default-footer
                  item-key="id"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="QuitarRegistroPago(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevoregpago" persistent max-width="800">
        <v-card>
          <v-card-title class="headline">
            Agregar Registro de Comprobante de Pago
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarRegistroPago">
                  Grabar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevoregpago = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <v-row row wrap>
              <v-col cols="12" lg="4" md="4">
                <v-menu
                  v-model="menufrcpago"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalrcpago"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      height="20px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="nuevoregpago.fecha"
                    @input="menufrcpago = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="4" md="4">
                <v-menu
                  v-model="menufrcpagoven"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalrcpagoven"
                      label="Vencimiento"
                      prepend-icon="mdi-calendar"
                      height="20px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="nuevoregpago.vencimiento"
                    @input="menufrcpagoven = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="4" md="4">
                <v-text-field
                  v-model="nuevoregpago.nrocomprobante"
                  label="N° Comp."
                  height="20px"
                  :rules="[rulesnrocomp.counter]"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" lg="6" md="6">
                <v-text-field
                  v-model="nuevoregpago.referencia"
                  label="Referencia"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" lg="6" md="6">
                <v-text-field
                  v-model="nuevoregpago.monto"
                  label="Monto"
                  type="number"
                  height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogverexportar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"> Exportar Listado </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="alineaizquierda">
                <v-select
                    v-model="formatosel"
                    :items="listaformatos"
                    label="Formato"
                    item-text="formato"
                    item-value="formato"
                    height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="exportarlistado">
              Exportar
            </v-btn>
            <v-btn color="red darken-1" text @click="dialogverexportar = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogcuotas" persistent max-width="1280">
        <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>CUOTAS DE LA CARRERA</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-actions>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="alineaderecha">
                  <v-btn color="green darken-1" text @click="SeleccionarCuotas">
                    Seleccionar Cuotas
                  </v-btn>
                  <v-btn
                        color="red darken-1"
                        text
                        @click="dialogcuotas = false"
                  >
                    Cancelar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="6" lg="6">
                  <v-select
                    v-model="cuotaidcarrera"
                    :items="listacarrerasalumno"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    height="20px"
                    v-on:change="SeleccionaCarreraCuota"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-select
                    v-model="cuotaanio"
                    :items="listaanioscarreraalumno"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                    v-on:change="ListarCuotas"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="ListarCuotas"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnascuotas"
                    :items="listacuotas"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idcuota"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.seleccionado="{ item }">
                      <v-simple-checkbox
                        v-model="item.seleccionado"
                        :disabled="!item.permiteseleccionar || !item.permitegenerarfactura"
                      ></v-simple-checkbox>
                    </template>
                    <template v-slot:item.estadocontable="{ item }">
                      <v-chip :color="getcolorestadocuota(item.estadocontable)" dark>
                        {{ item.estadocontable }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorAlumno from "../../components/SelectorAlumno.vue";
import SelectorPersona from '../../components/SelectorPersona.vue';
export default {
  name: "Facturas",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorAlumno: SelectorAlumno,
    SelectorPersona: SelectorPersona
  },
  data() {
    return {
      loading: false,
      usuario: "",
      usuariosede: 0,
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 6,
      roles: [],
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      listafacturas: [],
      columnasfacturas: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idfactura",
          width: 60,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 140,
        },
        {
          text: "Alumno",
          align: "center",
          sortable: true,
          value: "alumno",
          width: 220,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 220,
        },
        /* {
          text: "PV",
          align: "center",
          sortable: true,
          value: "pvcodigo",
          width: 80,
        },
        {
          text: "PVAFIP",
          align: "center",
          sortable: true,
          value: "pvcodafip",
          width: 110,
        }, */
        {
          text: "N°",
          align: "center",
          sortable: true,
          value: "nrocomprobantecompleto",
          width: 120,
        },
        /* {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipocomprobante",
          width: 80,
        }, */
        /* {
          text: "Subtotal",
          align: "center",
          sortable: true,
          value: "subtotal",
          width: 110,
        }, */
        /* {
          text: "IVA",
          align: "center",
          sortable: true,
          value: "iva",
          width: 100,
        }, */
        {
          text: "Total",
          align: "center",
          sortable: true,
          value: "total",
          width: 120,
        },
        {
          text: "CAE",
          align: "center",
          sortable: true,
          value: "cae",
          width: 100,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadocomprobante",
          width: 110,
        }
      ],
      facturaseleccionada: [],
      menufiltrofdesde: false,
      menufiltrofhasta: false,
      filtros: {
        desde: '',
        hasta: '',
        idpuntoventa: -1,
        facturanro: '',
        idalumno: 0,
        idpersonafactura: 0,
        concepto: ''
      },
      menuffac: false,
      dialognuevafactura: false,
      factura: {
        idalumno: 0,
        idpersonafactura: 0,
        concepto: '',
        idpuntoventa: 0,
        fecha: '',
        detalles: [],
        itemsabonos: [],
        usuario: ''
      },
      nuevodetalle: {
        id: 0,
        idconcepto: 0,
        descripcion: '',
        importe: 0.00
      },
      columnasdetalles: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "id",
          width: 70,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 90,
        },
        {
          text: "N° Mov.",
          align: "center",
          sortable: true,
          value: "idmovimientocc",
          width: 70,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 300,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 90,
        }
      ],
      itemabonoseleccionado: [],
      columnasabonos: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 30,
        },
        {
          text: "Forma Pago",
          align: "center",
          sortable: true,
          value: "formapago",
          width: 200,
        },
        {
          text: "Observación",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 300,
        },
        {
          text: "Importe",
          align: "center",
          sortable: true,
          value: "importe",
          width: 110,
        }
      ],
      listaconceptosafacturar: [],
      listapuntosventa: [],
      listapuntosventafiltro: [],
      listatiposdescrec: [
        {idtipo: 1, tipo: 'Descuento'},
        {idtipo: 2, tipo: 'Recargo'}
      ],
      facdistintotitular: false,
      itemsccseleccionado: [],
      fechacalculo: '',
      listacc: [],
      columnascc: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idmovimiento",
          width: 70,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 300,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 90,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 90,
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 90,
        },
        {
          text: "Vencim.",
          align: "center",
          value: "vencimientodmy",
          width: 115,
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "cuotaanio",
          width: 80,
        },
        {
          text: "N° Cuota",
          align: "center",
          sortable: true,
          value: "cuotanro",
          width: 80,
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "cuotacarrera",
          width: 120,
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "cuotatipo",
          width: 100,
        }
      ],
      dialognuevodetalleCC: false,
      facalumno: '',
      faccuit: '',
      facnrodoc: '',
      menufcalculo: false,
      fechacalculocc: '',
      dialogpagos: false,
      nuevoabono: {
        idformapago: 1,
        importe: 0.00,
        observacion: '',
        registros: []
      },
      columnasregistrosabono: [
        /* {
          text: "ID",
          align: "center",
          sortable: true,
          value: "id",
          width: 70,
        }, */
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fecha",
          width: 90,
        },
        {
          text: "N° Comp.",
          align: "center",
          sortable: true,
          value: "nrocomprobante",
          width: 120,
        },
        {
          text: "Ref.",
          align: "center",
          sortable: true,
          value: "referencia",
          width: 120,
        },
        {
          text: "Titular",
          align: "center",
          sortable: true,
          value: "titular",
          width: 180,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 100,
        },
        {
          text: "Vencim.",
          align: "center",
          sortable: true,
          value: "vencimiento",
          width: 110,
        }
      ],
      nuevoregpago: {
        // id: 0,
        // idregistro: 0,
        fecha: '',
        nrocomprobante: '',
        referencia: '',
        titular: '',
        monto: 0.00,
        vencimiento: ''
      },
      rulesnrocomp: {
        counter: value => value.length <= 10 || 'Máx. 10 cifras'
      },
      dialognuevoregpago: false,
      menufrcpago: false,
      menufrcpagoven: false,
      listaformaspago: [],
      dialogverexportar: false,
      formatosel: 'PDF',
      listaformatos: [{ formato: 'PDF' }, { formato: 'EXCEL' }],
      columnasnovedades: [
        {
          text: "Tipo Novedad",
          align: "center",
          sortable: true,
          value: "tiponovedad",
          width: 150,
        },
        {
          text: "Desde",
          align: "center",
          sortable: true,
          value: "desde",
          width: 90,
        },
        {
          text: "Hasta",
          align: "center",
          sortable: true,
          value: "hasta",
          width: 90,
        },
        {
          text: "# Desc.",
          align: "center",
          sortable: true,
          value: "montodescuento",
          width: 90,
        },
        {
          text: "% Desc.",
          align: "center",
          sortable: true,
          value: "porcentajedescuento",
          width: 90,
        },
        {
          text: "# Recgo",
          align: "center",
          sortable: true,
          value: "montorecargo",
          width: 90,
        },
        {
          text: "% Recgo",
          align: "center",
          sortable: true,
          value: "porcentajerecargo",
          width: 90,
        },
        {
          text: "Obs",
          align: "center",
          sortable: true,
          value: "observacion",
          width: 100,
        },
      ],
      listanovedadesalumno: [],
      dialogcuotas: false,
      cuotaidcarrera: 0,
      listacarrerasalumno: [],
      listacuotas: [],
      columnascuotas: [
        {
          text: "Sel",
          align: "center",
          sortable: true,
          value: "seleccionado",
          width: 70,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idcuota",
          width: 70,
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "anio",
          width: 80,
        },
        {
          text: "Cuota",
          align: "center",
          sortable: true,
          value: "nrocuota",
          width: 80,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 130,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "montocuota",
          width: 100,
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 100,
        },
        {
          text: "Vencim 1",
          align: "center",
          sortable: true,
          value: "vencimiento1",
          width: 90,
        },
        {
          text: "Vencim 2",
          align: "center",
          sortable: true,
          value: "vencimiento2",
          width: 90,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadocontable",
          width: 110,
        }
      ],
      cuotaanio: 0,
      listaanioscarreraalumno: [],
      listapersonasvinculadas: [],
      cursoactualalumno: ''
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    this.usuariosede = localStorage.getItem("idsede");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var roles = localStorage.getItem("rolesusuario");
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion=== 3).length > 0 ? true : false;
      this.filtros.desde= (new Date()).getFullYear().toString() + '-01-01';
      this.filtros.hasta= (new Date()).getFullYear().toString() + '-12-31';
      this.CargaCombosFiltros();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    CargaCombosFiltros () {
        const parametro= JSON.stringify({idsede: parseInt(this.usuariosede), solotipooficial: true, tipos: [1,2]});
        axios.post("contable/PostPuntosVenta",parametro, { headers: { "Content-Type": "application/json" }}).then((result) => {
          if(result.data.resultado===0){
            var talonariosedit = result.data.datos.slice();
            this.listapuntosventa = JSON.parse(JSON.stringify(talonariosedit));
            this.listapuntosventafiltro = result.data.datos;
            this.listapuntosventafiltro.unshift({ idpuntoventa: -1, nombre: "(TODOS)" });
            this.loading = false;
          }else{
            this.loading=false;
            this.MostrarMensaje('Error',result.data.resultadomensaje,false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    Listar (mensaje) {
      this.loading=true;
      var fecdesde = this.filtros.desde != '' && this.filtros.desde != null ? this.filtros.desde : ' ';
      var fechasta = this.filtros.hasta != '' && this.filtros.hasta != null ? this.filtros.hasta : ' ';
      var facturanro = this.filtros.facturanro != '' && this.filtros.facturanro != null ? this.filtros.facturanro : ' ';
      var idpersonafactura = this.filtros.idpersonafactura != '' && this.filtros.idpersonafactura != null && this.filtros.idpersonafactura != -1 ? this.filtros.idpersonafactura : 0;
      var idalumno = this.filtros.idalumno != '' && this.filtros.idalumno != null && this.filtros.idalumno != -1 ? this.filtros.idalumno : 0;
      var idptoventa = this.filtros.idpuntoventa != '' && this.filtros.idpuntoventa != null && this.filtros.idpuntoventa != -1 ? this.filtros.idpuntoventa : 0;
      var concepto =  this.filtros.concepto != '' && this.filtros.concepto != null ? this.filtros.concepto : ' ';

      axios.get("contable/ListaABMFactura/" + fecdesde +"/"+ fechasta +"/"+ facturanro +"/"+ concepto +"/"+ idptoventa +"/"+ idpersonafactura +"/"+ idalumno)
        .then((result) => {
          if(result.data.resultado===0){
            this.listafacturas = result.data.datos;
            this.loading=false;
            if (mensaje.length > 0) {
              this.MostrarMensaje("Error", mensaje, false);
            }
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    Nueva () {
      this.loading = true;
      this.tituloabm = "Nuevo Comprobante";
      this.factura= {
        idalumno: 0,
        idpersonafactura: 0,
        concepto: '',
        idpuntoventa: this.listapuntosventa.length>0 ? this.listapuntosventa[0].idpuntoventa : 0,
        fecha: this.fechaFormatoYMD(new Date()),
        detalles: [],
        itemsabonos: [],
        totalfactura: 0.00,
        usuario: this.usuario
      };
      this.listanovedadesalumno= [];
      if (this.$refs.selalumnoedit != null) {
        this.$refs.selalumnoedit.QuitarAlumno();
      }
      if (this.$refs.selpersonaedit != null) {
        this.$refs.selpersonaedit.QuitarFiltroPersona();
      }
      this.nuevodetalle= {
        id: 0,
        idconcepto: 0,
        descripcion: '',
        importe: 0.00
      };
      axios.get("referenciales/conceptofactura").then((result) => {
        if(result.data.resultado===0) {
          this.listaconceptosafacturartodos= result.data.datos;
          this.listaconceptosafacturar = result.data.datos.filter(c=> c.idconcepto>=6);
          axios.get("referenciales/formapago").then((result) => {
            if(result.data.resultado===0){
              this.listaformaspago = result.data.datos;
              this.dialognuevafactura = true;
              this.loading = false;
            }else{
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
      /*
        this.recibo = {
        idpuntoventa: "",
        idpersona: 0,
        persona: "",
        nromatriculado: 0,
        fecha: this.fechaFormatoVmenu(new Date()), //new Date().toLocaleDateString('en-CA'),
        itemsdebe: [],
        itemssaldofavor: [],
        itemsdescuentos: [],
        montorecibo: 0,
        montoapagar: 0,
        montodescuentos: 0,
        itemsabonos: [
          {
            idformapago: 10,
            descripcion: "EFECTIVO (CAJA)",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 2,
            descripcion: "CHEQUES",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 12,
            descripcion: "DEPOSITO BANCARIO",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 6,
            descripcion: "TRANSFERENCIAS BANCARIAS",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 9,
            descripcion: "DOLARES",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 11,
            descripcion: "OTRAS CUENTAS",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
          {
            idformapago: 99,
            descripcion: "HABER CC",
            importe: 0,
            registros: [],
            registroshcc: [],
            valordolar: 0,
          },
        ],
        usuario: this.usuario,
        titulo: "",
      };
      this.itemsccmatseleccionado = [];
      this.itemdebeseleccionado = [];
      this.itemdescuentoseleccionado = [];
      this.itemabonoseleccionado = [];
      this.actualizatalonario();
      axios
        .get("parametrosistema/10")
        .then((result) => {
          var valor = result.data.toString().replace(",", ".");
          this.recibo.itemsabonos.filter(
            (f) => f.idformapago === 9
          )[0].valordolar = valor;
          axios
            .get("referenciales/tiposdescuentosrecibo")
            .then((result) => {
              this.listatiposdescuentos = result.data;
              this.dialognuevorecibo = true;
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        }); */
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    GrabarFactura () {
      this.loading = true;
      this.factura.totalfactura= parseFloat(parseFloat(this.sumamontofactura()+this.sumamontorecargos())+this.sumamontodescuentos());
      var valida = this.ValidaDatosFactura();
      if (valida === "OK") {
        const factura = JSON.stringify(this.factura);
        axios.post("contable/PostFactura", factura, { headers: {"Content-Type": "application/json", }})
          .then((result) => {
            var d = result.data;
            if (d.resultado === 0) {
              this.dialognuevafactura = false;
              this.PreguntarExportar(d.nrofactura.toString(), d.idfactura, true);
            } else {
              var mensaje = "";
              var facturaguardada = false;
              if (d.resultado === 1 || d.resultado === 99) {
                //Error al generar factura en BD
                mensaje = d.resultadomensaje;
              } else if (d.resultado === 2) {
                //OK generar factura en BD pero Error al intentar informar al AFIP
                facturaguardada = true;
                mensaje= d.resultadomensaje;
              }
              if (facturaguardada === false) {
                this.loading = false;
                this.MostrarMensaje("Error", mensaje, false);
              } else {
                this.dialognuevafactura = false;
                this.Listar(mensaje);
              }
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      } else {
        this.loading = false;
        this.MostrarMensaje("Error", valida, false);
      }
    },
    ValidaDatosFactura () {
      var valido = "OK";
      if(this.factura.idalumno === null || this.factura.idalumno==='' ) {
        valido = "Debe seleccionar el alumno al cual se le debe cobrar!!!";
      }
      if (this.factura.fecha === null || this.factura.fecha === '') {
        valido = "Debe seleccionar fecha de la factura!!!";
      }
      if (this.factura.concepto === null || this.factura.concepto === '') {
        valido = "Debe ingresar el concepto de la factura!!!";
      }
      if (this.factura.idpuntoventa === null || this.factura.idpuntoventa === '') {
        valido = "Debe seleccionar el punto de venta!!!";
      }
      if(this.factura.detalles.length===0) {
        valido = "Debe ingresar los items de la factura!!!";
      }

      if(this.factura.itemsabonos.length>0 && this.factura.detalles.filter(d=> d.tipomov==='D' && d.idtipodetalle===10).length===0) {
        if(this.sumatotal()!=0){
            valido = "El total de los abonos debe ser igual al monto de la factura!!!";
        }
      }
      if(this.faccuit.length===0 && this.facnrodoc.length===0) {
        valido = "La persona seleccionada no tiene CUIT ni Nro de Documento. No se puede facturar!!!";
      }
      return valido;
    },
    async PreguntarExportar (nro, idfactura, actualizagrilla) {
      if (await this.$refs.confirm.open("Factura Generada!!!", "Fue generada la Factura Nº " + nro + ". Desea ver o exportar la misma?")) {
        // exportar pdf factura
        this.exportarFactura(idfactura, actualizagrilla);
      } else {
        if(actualizagrilla){
          this.Listar('');
        }else{
          this.loading = false;
        }
      }
    },
    exportarFactura (idfactura, actualizagrilla) {
      this.loading = true;
      var idrep = 1;  //cae != null && cae.length > 0 ? 22 : 7;
      axios.post("reportes/GetReporte",
        {idreporte: idrep, formato: "PDF",nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idfactura", valor: idfactura.toString() }] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
            if (actualizagrilla === true) {
              this.Listar('');
            }
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    async InformaAFIP () {
        if (await this.$refs.confirm.open("Informar Factura", "Está seguro que desea informar la factura a la AFIP?")) {
          this.loading = true;
          var factura = { idfactura: this.facturaseleccionada[0].idfactura, usuario: this.usuario,};
          axios.put("contable/PutFacturaInformarAFIP", factura, { headers: { "Content-Type": "application/json"},})
            .then((result) => {
              var d = result.data;
              if (d.resultado === 0) {
                this.facturaseleccionada = [];
                this.Listar("");
              } else {
                var mensaje = "";
                mensaje = d.resultadomensaje;
                this.loading = false;
                this.MostrarMensaje("Error", mensaje, false);
              }
            })
            .catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
        }
    },
    async AbreCuadroAnularFactura () {
      if (await this.$refs.confirm.open("Anular Factura", "Está seguro de anular la factura " + this.facturaseleccionada[0].idfactura.toString() + "?")) {
        this.loading = true;
        var factura = { idfactura: this.facturaseleccionada[0].idfactura, usuario: this.usuario };
        axios.put("contable/PutFacturaAnular", factura, { headers: { "Content-Type": "application/json" }})
          .then((result) => {
            var d = result.data;
            if (d.resultado === 0) {
              this.facturaseleccionada = [];
              this.Listar('');
            } else {
              var mensaje = "";
              var facguardada = false;
              if (d.resultado === 1 || d.resultado === 99) {
                //Error al anular factura en BD
                mensaje = d.resultadomensaje;
              } else if (d.resultadogeneral === 2) {
                //OK generar recibo en BD pero Error al intentar informar al AFIP la nota de credito
                facguardada = true;
                mensaje = d.resultadomensaje;
              }
              if (facguardada === false) {
                this.loading = false;
                this.MostrarMensaje("Error", mensaje, false);
              } else {
                this.Listar(mensaje);
              }
            }
          })
          .catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }
    },
    AbrirCuadroReImprimir () {
      this.loading = true;
      this.exportarFactura(this.facturaseleccionada[0].idfactura, false);
    },
    AbrirCuadroImprimirExportar () {
      this.dialogverexportar = true;
    },
    exportarlistado() {
      this.loading=true;
      var fecdesde = this.filtros.desde != '' && this.filtros.desde != null ? this.filtros.desde : ' ';
      var fechasta = this.filtros.hasta != '' && this.filtros.hasta != null ? this.filtros.hasta : ' ';
      var facturanro = this.filtros.facturanro != '' && this.filtros.facturanro != null ? this.filtros.facturanro : ' ';
      var idpersonafactura = this.filtros.idpersonafactura != '' && this.filtros.idpersonafactura != null && this.filtros.idpersonafactura != -1 ? this.filtros.idpersonafactura : 0;
      var idalumno = this.filtros.idalumno != '' && this.filtros.idalumno != null && this.filtros.idalumno != -1 ? this.filtros.idalumno : 0;
      var idptoventa = this.filtros.idpuntoventa != '' && this.filtros.idpuntoventa != null && this.filtros.idpuntoventa != -1 ? this.filtros.idpuntoventa : 0;
      var concepto =  this.filtros.concepto != '' && this.filtros.concepto != null ? this.filtros.concepto : ' ';
      axios.post("reportes/GetReporte",{ idreporte: 6, formato: this.formatosel,nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [
              { orden: 1, nombre: "fecdesde", valor: fecdesde },
              { orden: 2, nombre: "fechasta", valor: fechasta },
              { orden: 3, nombre: "facturanro", valor: facturanro },
              { orden: 5, nombre: "idpersonafactura", valor: idpersonafactura },
              { orden: 6, nombre: "idalumno", valor: idalumno },
              { orden: 7, nombre: "idptoventa", valor: idptoventa },
              { orden: 8, nombre: "concepto", valor: concepto }
            ]}, { headers: { "Content-Type": "application/json" }}
        ).then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    asignapersonafiltro (value) {
      this.filtros.idpersonafactura= value!=null ? value.idpersona : 0;
    },
    asignaalumnofiltro (value) {
      this.filtros.idalumno = value!=null ? value.idalumno : 0;
      if(this.$refs.selpersonafiltro!=null){
        this.$refs.selpersonafiltro.idalumno= this.filtros.idalumno;
      }
    },
    asignaalumnoedit (value) {
      this.factura.idalumno = value!=null ? value.idalumno : 0;
      this.facalumno= value!=null ? value.apellido + ' ' + value.nombre : '';
      this.faccuit= value!=null ? value.cuit : '';
      this.facnrodoc= value!=null ? value.nrodoc : '';
      this.cursoactualalumno= value!=null ? value.cursoactual : '';
      if(this.$refs.selalumnoedit!=null) {
        this.$refs.selalumnoedit.idalumno= this.factura.idalumno;
      }
      if(this.factura.idalumno!=null && this.factura.idalumno!=0) {
        var idpersona= this.factura.idalumno;
        axios.get('alumno/responsablesvinculadosfactura/ / /' + idpersona + '/0')
          .then((result) => {
            if(result.data.resultado===0) {
              this.listapersonasvinculadas = result.data.datos;
              this.factura.idpersonafactura= this.factura.idalumno;
              this.loading = false;
              /* axios.get('alumno/novedadesalumno/ / /' + this.factura.idalumno)
                .then((result) => {
                  if(result.data.resultado===0){
                    this.listanovedadesalumno = result.data.datos;
                    this.loading = false;
                  }else{
                    this.loading = false;
                    this.MostrarMensaje('Error', result.data.resultadomensaje);
                  }
                }).catch((error) => {
                  this.loading = false;
                  this.MostrarMensaje('Error', error);
                }) */
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
      }
    },
    /* asignapersonaedit (value) {
      this.factura.idpersonafactura= value!=null ? value.idpersona : 0;
    }, */
    AgregaDetalle () {
      if(this.nuevodetalle.idconcepto!=null && this.nuevodetalle.idconcepto!=''){
        if (this.nuevodetalle.importe > 0) {
            this.loading = true;
            var id = 0;
            id = this.factura.detalles.length > 0 ? this.factura.detalles[this.factura.detalles.length - 1].id+1 : 1;
            var monto= this.listaconceptosafacturar.filter(c=> c.idconcepto===this.nuevodetalle.idconcepto)[0].tipomov==='D' ? parseFloat(this.nuevodetalle.importe) : parseFloat(this.nuevodetalle.importe)*parseFloat(-1);
            this.factura.detalles.push({ idtipodetalle: this.listaconceptosafacturar.filter(c=> c.idconcepto===this.nuevodetalle.idconcepto)[0].idtipodetalle, idconcepto: this.nuevodetalle.idconcepto, concepto: this.listaconceptosafacturar.filter(c=> c.idconcepto===this.nuevodetalle.idconcepto)[0].nombre,idcuota: -1, idmovimientocc: -1,id: id, descripcion: this.nuevodetalle.descripcion, importe: monto, idregistrocuotamatricula: null});
            this.nuevodetalle.idconcepto = 1;
            this.nuevodetalle.descripcion = '';
            this.nuevodetalle.importe = 0;
            this.loading = false;
            if(this.factura.detalles.filter(d=> d.idtipodetalle===6).length>0) {
              this.Imputaautomatico();
            }
        } else {
            this.MostrarMensaje("Error", "Debe ingresar un importe válido!",false);
        }
      }else{
        this.MostrarMensaje("Error", "Debe seleccionar un concepto a facturar!",false);
      }
    },
    async QuitarDetalle (item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.factura.detalles.splice(this.factura.detalles.indexOf(item), 1);
        if(item.idtipodetalle===6){
          this.Imputaautomatico();
        }
      }
    },
    BuscaItemCC () {
      this.loading = true;
      this.fechacalculocc = this.fechaFormatoYMD(new Date());
      this.itemsccseleccionado = [];
      if (this.factura.idalumno != null && this.factura.idalumno != "") {
        this.ListaCCAlumno();
      } else {
        this.loading = false;
        this.MostrarMensaje("Error", "Falta Seleccionar el Alumno!!!", false);
      }
    },
    ListaCCAlumno () {
      const param= JSON.stringify({ idalumno: this.factura.idalumno, fechacalculo: this.fechacalculocc });
      axios.post("alumno/PostCCAlumno", param, {
          headers: {
            "Content-Type": "application/json",
          },
        }).then((result) => {
          if(result.data.resultado===0){
            this.listacc = result.data.datos;
            this.dialognuevodetalleCC = true;
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    AgregarPago () {
      this.nuevoabono= {
        idformapago: 1,
        importe: 0.00,
        observacion: '',
        registros: []
      };
      this.dialogpagos=true;
    },
    GuardarPago () {
      if(this.nuevoabono.importe>0){
        this.factura.itemsabonos.push({ idformapago: parseInt(this.nuevoabono.idformapago), formapago: this.listaformaspago.filter(f=> f.idformapago===this.nuevoabono.idformapago)[0].nombre,importe: parseFloat(this.nuevoabono.importe),observacion: this.nuevoabono.observacion, registros: this.nuevoabono.registros });
        this.dialogpagos=false;
        if(this.factura.detalles.filter(d=> d.idtipodetalle===6).length>0) {
          this.Imputaautomatico();
        }
      }else{
        this.MostrarMensaje('Error', 'El importe debe ser mayor a 0',false);
      }
    },
    async QuitarPago (item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.factura.itemsabonos.splice(this.factura.itemsabonos.indexOf(item), 1);
        if(this.factura.detalles.filter(d=> d.idtipodetalle===6).length>0) {
          this.Imputaautomatico();
        }
      }
    },
    AgregarRegistroPago () {
      this.nuevoregpago= {
        // id: 0,
        // idregistro: 0,
        fecha: '',
        nrocomprobante: '',
        referencia: '',
        titular: '',
        monto: 0.00,
        vencimiento: ''
      };
      this.dialognuevoregpago=true;
    },
    GrabarRegistroPago () {
      //this.nuevoabono.registros.push({ id: this.nuevoregpago.id, idregistro: this.nuevoregpago.idregistro, fecha: this.nuevoregpago.fecha, nrocomprobante: this.nuevoregpago.nrocomprobante, referencia: this.nuevoregpago.referencia, monto: this.nuevoregpago.monto, vencimiento: this.nuevoregpago.vencimiento })
      this.nuevoabono.registros.push({ fecha: this.nuevoregpago.fecha, nrocomprobante: this.nuevoregpago.nrocomprobante, referencia: this.nuevoregpago.referencia, titular: this.nuevoregpago.titular, monto: this.nuevoregpago.monto, vencimiento: this.nuevoregpago.vencimiento })
      this.dialognuevoregpago=false;
    },
    async QuitarRegistroPago (item) {
      if (await this.$refs.confirm.open("Confirmar Borrado","Esta seguro de querer quitar el registro?")) {
        this.nuevoabono.registros.splice(this.nuevoabono.registros.indexOf(item), 1);
      }
    },
    SeleccionarItemsCC () {
      if(this.itemsccseleccionado.length>0){
        var i=0;
        var id = 0;
        var idconcepto=0;
        var concepto='';
        this.factura.detalles= [];
        for(i=0; i<this.itemsccseleccionado.length;i++){
            id = this.factura.detalles.length > 0 ? this.factura.detalles[this.factura.detalles.length - 1].id+1 : 1;
            idconcepto = this.itemsccseleccionado[i].idcuota!=null ? this.itemsccseleccionado[i].cuotaidtipo===1 ? 5 : 1 : 9;
            concepto= this.listaconceptosafacturartodos.filter(c=> c.idconcepto===idconcepto)[0].nombre;
            this.factura.detalles.push({ idtipodetalle: this.listaconceptosafacturar.filter(c=> c.idconcepto===idconcepto)[0].idtipodetalle, idconcepto: idconcepto, concepto: concepto,idcuota: -1, idmovimientocc: this.itemsccseleccionado[i].idmovimiento,id: id, descripcion: this.itemsccseleccionado[i].descripcion, importe: parseFloat(this.itemsccseleccionado[i].saldo), idregistrocuotamatricula: null});
        }
        this.dialognuevodetalleCC=false;
        if(this.factura.itemsabonos.length>0 && this.factura.detalles.filter(d=> d.idtipodetalle===6).length>0){
          this.Imputaautomatico();
        }
      }else{
        this.MostrarMensaje('Error','Debe seleccionar items de la Cuenta Corriente!',false);
      }
    },
    sumamontofactura () {
      var total = 0.00;
      var i=0;
      for(i=0;i<this.factura.detalles.filter(d=> d.idtipodetalle===1 || d.idtipodetalle===4 || d.idtipodetalle===5 || d.idtipodetalle===6).length;i++){
        total= parseFloat(total) + parseFloat(this.factura.detalles.filter(d=> d.idtipodetalle===1 || d.idtipodetalle===4 || d.idtipodetalle===5 || d.idtipodetalle===6)[i].importe)
      }
      return parseFloat(total);
    },
    sumamontodescuentos () {
      var total = 0.00;
      var i=0;
      for(i=0;i<this.factura.detalles.filter(d=> d.idtipodetalle===2).length;i++){
        total= parseFloat(total) + parseFloat(this.factura.detalles.filter(d=> d.idtipodetalle===2)[i].importe*-1)
      }
      var totaldevolver= parseFloat(total)>0 ? -parseFloat(total) : 0;
      return totaldevolver;
    },
    sumamontorecargos () {
      var total = 0.00;
      var i=0;
      for(i=0;i<this.factura.detalles.filter(d=> d.idtipodetalle===3 || d.idtipodetalle===7).length;i++){
        total= parseFloat(total) + parseFloat(this.factura.detalles.filter(d=> d.idtipodetalle===3 || d.idtipodetalle===7)[i].importe)
      }
      return parseFloat(total);
    },
    sumamontopagos () {
      var total = 0.00;
      var i=0;
      for(i=0;i<this.factura.itemsabonos.length;i++){
        total= parseFloat(total) + parseFloat(this.factura.itemsabonos[i].importe);
      }
      var totaldevolver= parseFloat(total)>0 ? -parseFloat(total) : 0;
      return totaldevolver;
    },
    sumatotal () {
      var total = 0.00;
      /*var i=0;
       for(i=0;i<this.factura.detalles.filter(d=> d.idtipodetalle===2).length;i++){
        total= parseFloat(total) + parseFloat(this.factura.detalles.filter(d=> d.idtipodetalle===2)[i].importe)
      } */
      total= this.sumamontofactura() + this.sumamontorecargos() + this.sumamontodescuentos() + this.sumamontopagos();
      return parseFloat(total);
    },
    sumaitemsselcc () {
      var total = 0.00;
      var i=0;
      for(i=0; i<this.itemsccseleccionado.length;i++){
        total= parseFloat(total) + parseFloat(this.itemsccseleccionado[i].saldo);
      }
      return parseFloat(total);
    },
    getcolor(idestadocomprobante) {
      if (idestadocomprobante === 1) {return "grey";}
      else if (idestadocomprobante === 2) {return "green";}
      else if (idestadocomprobante === 3) {return "blue";}
      else if (idestadocomprobante === 4) {return "red";}
    },
    getcolorestadocuota(estado){
      if (estado === 'SIN ABONAR') {return "grey";}
      else if (estado === 'FACTURA GENERADA') {return "green";}
      else if (estado === 'FACTURA REGENERADA') {return "green";}
      else if (estado === 'FACTURA ABONADA') {return "blue";}
      else if (estado === 'FACTURA VENCIDA') {return "red";}
      else if (estado === 'FACTURA ANULADA') {return "black";}
    },
    getcolorcae(cae) {
      if (cae!=null && cae.length > 0) {return "green";}
      else {return "red";}
    },
    BuscaCuotas () {
      if (this.factura.idalumno != null && this.factura.idalumno != "") {
        this.loading=true;
        axios.get('alumno/carrerasalumnoadmin/0/ /' + this.factura.idalumno + '/0')
          .then((result) => {
            if(result.data.resultado===0){
              this.listacarrerasalumno = result.data.datos;
              if(this.listacarrerasalumno.length>0){
                this.cuotaidcarrera=this.listacarrerasalumno[0].idcarrera;
                var ia= 0;
                var anioactual= (new Date()).getFullYear();
                this.listaanioscarreraalumno=[];
                var anioing= this.listacarrerasalumno.filter(c=> c.idcarrera===this.cuotaidcarrera)[0].anioingreso;
                if(anioing<=anioactual){
                  for(ia=anioing;ia<=anioactual+1;ia++){
                    this.listaanioscarreraalumno.push({anio: ia});
                  }
                }else{
                  for(ia=anioactual;ia<=anioing+1;ia++){
                    this.listaanioscarreraalumno.push({anio: ia});
                  }
                }
                if(this.listaanioscarreraalumno.length>0) {
                  if(this.listaanioscarreraalumno.filter(c=> c.anio===anioactual).length>0){
                    this.cuotaanio= anioactual;
                  }else{
                    this.cuotaanio= this.listaanioscarreraalumno[0].anio;
                  }
                  this.dialogcuotas= true;
                  this.ListarCuotas();
                }else{
                  this.dialogcuotas= true;
                }
                
             
                // var ia= 0;
                // var anioactual= (new Date()).getFullYear()+1;
                // this.listaanioscarreraalumno=[];
                // for(ia=this.listacarrerasalumno[0].anioingreso; ia<=anioactual;ia++){
                //   this.listaanioscarreraalumno.push({anio: ia});
                // }
                // if(this.listaanioscarreraalumno.length>0){
                //   this.cuotaanio=this.listaanioscarreraalumno[this.listaanioscarreraalumno.length-1].anio;
                //   this.dialogcuotas= true;
                //   this.ListarCuotas();
                // }
              }
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
      } else {
        this.loading = false;
        this.MostrarMensaje("Error", "Falta Seleccionar el Alumno!!!", false);
      }
    },
    ListarCuotas () {
      this.loading=true;
      var param= JSON.stringify({idalumno: parseInt(this.factura.idalumno), idcarrera: parseInt(this.cuotaidcarrera), anio: parseInt(this.cuotaanio) });
      axios.post("contable/PostCuotasClienteAdmin", param, { headers: {"Content-Type": "application/json" }})
        .then((result) => {
          if(result.data.resultado===0) {
            this.listacuotas = result.data.datos;  //.filter(d=> d.estadocontable==='SIN ABONAR'); // || d.estadocontable==='FACTURA GENERADA');
            this.loading=false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
      })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    SeleccionarCuotas () {
      if(this.listacuotas.filter(c=> c.seleccionado===true).length>0){
        var i=0;
        var id = 0;
        var idconcepto=0;
        var concepto='';
        this.factura.detalles= [];
        for(i=0; i<this.listacuotas.length; i++){
            if(this.listacuotas[i].seleccionado===true){
                id = this.factura.detalles.length > 0 ? this.factura.detalles[this.factura.detalles.length - 1].id+1 : 1;
                if(this.listacuotas[i].idregistrocuotamatricula===null) {
                  idconcepto = 1;
                }else {
                  idconcepto = 5;
                }
                concepto= this.listaconceptosafacturartodos.filter(c=> c.idconcepto===idconcepto)[0].nombre;
                this.factura.detalles.push({ idtipodetalle: 1, idconcepto: idconcepto, concepto: concepto,idcuota: this.listacuotas[i].idcuota, idmovimientocc: -1,id: id, descripcion: this.listacuotas[i].descripcion, importe: parseFloat(this.listacuotas[i].saldo), idregistrocuotamatricula: this.listacuotas[i].idregistrocuotamatricula});
                var n=0;
                for(n=0; n<this.listacuotas[i].novedades.length; n++){
                    var item= this.listacuotas[i].novedades[n];
                    id = this.factura.detalles.length > 0 ? this.factura.detalles[this.factura.detalles.length - 1].id+1 : 1;
                    var montonov=0;
                    if(item.tipomov==='H') {
                        if(item.montodescuento!=null && item.montodescuento>0) {
                            montonov=parseFloat(item.montodescuento)*parseFloat(-1);
                        } else{
                            montonov=(parseFloat(item.porcentajedescuento/100)*parseFloat(this.listacuotas[i].saldo))*parseFloat(-1);
                        }
                    } else if(item.tipomov==='D') {
                        if(item.montorecargo!=null && item.montorecargo>0) {
                            montonov=parseFloat(item.montorecargo);
                        } else {
                            montonov=parseFloat(item.porcentajerecargo/100)*parseFloat(this.listacuotas[i].saldo);
                        }

                        if((item.montorecargovencim2 != null && item.montorecargovencim2 != 0) || item.porcentajerecargovencim2!= null && item.porcentajerecargovencim2!= 0)
                        {
                          if(this.listacuotas[i].vencimiento2YMD === null || (new Date()) > (new Date(this.listacuotas[i].vencimiento2YMD)))
                          {
                            montonov = item.montorecargovencim2 != null && item.montorecargovencim2 != 0 ? montonov+item.montorecargovencim2 : montonov+(montonov*(item.porcentajerecargovencim2/100));
                          }
                        }
                    }
                    this.factura.detalles.push({ idtipodetalle: item.idtipodetalle, idconcepto: item.idconceptofactura, concepto: item.conceptofactura,idcuota: 0, idmovimientocc: -1,id: id, descripcion: item.tiponovedad, importe: parseFloat(montonov), idregistrocuotamatricula: null});
                }
            }
        }
        this.dialogcuotas=false;
      }else{
        this.MostrarMensaje('Error','Debe seleccionar al menos una cuota abonar!',false);
      }
    },
    ImprimirNotaCredito () {
      this.loading = true;
      var idfactura= this.facturaseleccionada[0].idfactura;
      var idrep = 3;
      axios.post("reportes/GetReporte",
        {idreporte: idrep, formato: "PDF",nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idfactura", valor: idfactura.toString() }] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    SeleccionaPersonaFactura () {
      var per=this.listapersonasvinculadas.filter(p=> p.idpersona===this.factura.idpersonafactura)[0];
      this.faccuit= per!=null ? per.cuit : '';
      this.facnrodoc= per!=null ? per.nrodoc : '';
    },
    SeleccionaCarreraCuota () {
      var ia= 0;
      var anioactual= (new Date()).getFullYear()+1;
      this.listaanioscarreraalumno=[];
      var anioing= this.listacarrerasalumno.filter(c=> c.idcarrera===this.cuotaidcarrera)[0].anioingreso;
      if(anioing<=anioactual){
        for(ia=anioing;ia<=anioactual;ia++){
          this.listaanioscarreraalumno.push({anio: ia});
        }
      }else{
        for(ia=anioactual;ia<=anioing+1;ia++){
          this.listaanioscarreraalumno.push({anio: ia});
        }
      }
      if(this.listaanioscarreraalumno.length>0) {
        this.cuotaanio= this.listaanioscarreraalumno[0].anio;
        this.ListarCuotas();
      }
    },
    Imputaautomatico() {
      var totaldinero = parseFloat((this.sumamontopagos()*-1) + (this.sumamontodescuentos()*-1));
      var nf = 0;
      for (nf = 0; nf < this.factura.detalles.filter(d=> d.idtipodetalle===1 || d.idtipodetalle===4 || d.idtipodetalle===5 || d.idtipodetalle===6).length; nf++) {
        var item= this.factura.detalles.filter(d=> d.idtipodetalle===1 || d.idtipodetalle===4 || d.idtipodetalle===5 || d.idtipodetalle===6)[nf];
        if(totaldinero>0) {
          if (totaldinero >= parseFloat(item.importe)) {
            totaldinero = (parseFloat(totaldinero) - parseFloat(item.importe)).toFixed(2);
          } else {
            item.importe = parseFloat(totaldinero);
            totaldinero = 0;
          }
        }
      }
    },
  },
  computed: {
    fechalocalfdesde: function () {
      if (this.filtros.desde != null && this.filtros.desde != "") {
        var fecha = new Date(this.filtros.desde);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfhasta: function () {
      if (this.filtros.hasta != null && this.filtros.hasta != "") {
        var fecha = new Date(this.filtros.hasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfactura: function () {
      if (this.factura.fecha != null && this.factura.fecha != "") {
        var fecha = new Date(this.factura.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalrcpago: function () {
      if (this.nuevoregpago.fecha != null && this.nuevoregpago.fecha != "") {
        var fecha = new Date(this.nuevoregpago.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalrcpagoven: function () {
      if (this.nuevoregpago.vencimiento != null && this.nuevoregpago.vencimiento != "") {
        var fecha = new Date(this.nuevoregpago.vencimiento);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfcalculo: function () {
      if (this.fechacalculocc != null && this.fechacalculocc != "") {
        var fecha = new Date(this.fechacalculocc);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.filadeuda td {
    color: red;
}
.textoColorBlanco {
    color: white;
}

.filadescuento td {
    color: green;
}

.filatotal td {
    color: blue;
}

.titulocardchico {
  padding: 8px !important;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa45 {
  width: 45%;
}
.ocupa50 {
  width: 50%;
}
.ocupa60 {
  width: 60%;
}
.ocupa75 {
  width: 75%;
}
.ocupa80 {
  width: 80%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  color: white;
  background-color: dimgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegrita {
  font-weight: bold !important;
}
.textoNegritaTitulo {
  font-weight: bold !important;
  font-size: medium;
}
.textoNegritaMontos {
  font-weight: bold !important;
  font-size: 11pt;
  padding-right: 10px;
}
.margenizquierdo{
    padding-left: 10px;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
.textoNegritaAzul {
  color: rgba(28, 31, 230, 0.767) !important;
  font-weight: bold !important;
}
.container {
  max-width: unset !important;
}
</style>
